import { IInactiveUserEmailLog } from '@api/models/analytics.model';
import { IClient, IUser } from '@api/models';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface InactiveUserEmailLogsListProps {
    isLoading: boolean;
    logs: IInactiveUserEmailLog[];
}

const InactiveUserEmailList = ({ isLoading, logs }: InactiveUserEmailLogsListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={logs}
            columns={[{ header: 'Date' }, { header: 'User' }, { header: 'Client' }]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/users/${(row.user as IUser)._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.user as IUser).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.client as IClient).name}
                        </Link>
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default InactiveUserEmailList;
